class CtaWrapper extends HTMLElement {
  constructor() {
    super();

    this.links = this.querySelectorAll('a[href^="#"]');
    this.links.forEach((link) => {
      link.addEventListener('click', this.handleNavigation.bind(this));
    });
  }

  handleNavigation(e) {
    const href = e.currentTarget.getAttribute('href');
    const target = document.querySelector(href);

    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

customElements.define('cta-wrapper', CtaWrapper);
